import './ModalButtons.scss';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class ModalButtons extends React.Component {
    static propTypes ={
        buttonCount: PropTypes.number.isRequired
    };

    render() {
        return (
            <div className={classNames('c-modal-buttons', 'modal__buttons', {
                'one-button': this.props.buttonCount === 1,
                'two-buttons': this.props.buttonCount === 2,
                'three-buttons': this.props.buttonCount === 3
            })}>
                {this.props.children}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Modal/ModalButtons/index.js